/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import {
  colors,
  MenuSeparator,
  sizes,
  Spacer,
  TextInput,
  TypeRampV2,
} from '@smartsheet/lodestar-core';
import { ToolbarChevronUpIcon } from '@smartsheet/lodestar-icons';
import { noop } from 'lodash';
import React, { useState } from 'react';
import useCollapse from 'react-collapsed';
import { useTranslation } from 'react-i18next';
import { CopyButton } from '../../../../common/CopyButton/CopyButton';

interface OutputProps {
  value: string;
}

export const Output = ({ value }: OutputProps) => {
  const { t: translate } = useTranslation();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { getToggleProps, getCollapseProps } = useCollapse({
    isExpanded,
  });

  const outputStyle = css`
    margin-bottom: ${sizes.large}px;
  `;

  const style = css`
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    :hover,
    :focus {
      .chevron-container {
        background-color: ${colors.focusLight20};
      }
    }
  `;

  const labelStyle = css`
    line-height: ${sizes.xLarge}px !important;
    width: calc(100% - ${sizes.xLarge}px);
  `;

  const chevronContainerStyle = css`
    border-radius: 2px;
    box-sizing: border-box;
    height: ${sizes.xLarge}px;
    width: ${sizes.xLarge}px;
    padding: calc(11px / 2);
  `;

  const chevronStyle = css`
    transition: transform 200ms;
    ${isExpanded ? 'transform: rotate(180deg)' : 'transform: rotate(90deg)'}
  `;

  return (
    <Spacer css={outputStyle} orientation="column" space="large">
      <MenuSeparator />
      <div
        css={style}
        {...getToggleProps({
          onClick: () => {
            setIsExpanded(!isExpanded);
          },
        })}
      >
        <TypeRampV2 system="lodestar" variant={'headerSmall'} css={labelStyle}>
          {translate('common:output')}
        </TypeRampV2>
        <div className="chevron-container" css={chevronContainerStyle}>
          <ToolbarChevronUpIcon css={chevronStyle} />
        </div>
      </div>
      <div {...getCollapseProps()}>
        <TextInput
          value={value}
          readOnly
          onChange={noop}
          contentAfter={<CopyButton value={value} />}
        />
      </div>
    </Spacer>
  );
};
